<div class="order-pricing">
	@if ((showPricingChangedInfo() || isPricingChanged) && isEmployeeLogged()) {
		<div class="pricing-changed-info">
			This estimate is based on outdated pricing because one of your country's pricing parameters has recently been updated.
			To reflect current pricing, initiate a sales lead takeover or editing of customer data and click save.
			The prices will then be automatically updated.
		</div>
	}
	@for (product of products; track $index) {
		<div class="product-header">
			<div style="display: flex;">
				<h6 style="margin-top: -3px;" class="standard-name">{{ 'pricing-details.label' | translate: {standard: product.standard.name | standardName} }}</h6>
				<change-label [visible]="isTotalPriceChangedFor(product)" [changeSet]="changeSet"></change-label>
			</div>
			@if (collapsable) {
				<a class="toggle-view-section" (click)="toggleVisibility(product)">
					{{ (isVisible(product) ? 'common.hide' : 'common.show') | translate }}
					<nb-icon icon="{{isVisible(product) ? 'arrow-ios-upward-outline' : 'arrow-ios-downward-outline'}}"></nb-icon>
				</a>
			}
		</div>
		<div [ngClass]="{'hide-section': !isVisible(product)}" id="product-pricing-{{product.standard.name}}" class="product-pricing">
			<product-pricing [pricing]="product.pricing" [orderUuid]="orderUuid" [includeOffsiteDays]="includeOffsiteDays"></product-pricing>
			@if (withPricingAdjustmentsEditMode) {
				<pricing-adjustments [order]="order" [product]="product" [changeSet]="changeSet"
									 [intermediatePriceAdjustments]="getAdjustmentsForProduct(product)"
									 [hackForCertificationFee]="hackForCertificationFee"
									 [priceAdjustmentsConfig]="priceAdjustmentsConfig">
				</pricing-adjustments>
			}
			@if (!withPricingAdjustmentsEditMode) {
				<pricing-adjustments-details [product]="product" [changeSet]="changeSet" [showDailyRate]="showDailyRate" [order]="order"></pricing-adjustments-details>
			}
		</div>
	}
	@if (showSummary) {
		<pricing-summary [orderCorrelationId]="orderCorrelationId" [allowPdfDownload]="allowPdfDownload" [pricings]="pricings()" [clientView]="isClient" [show3YearsTotalForClient]="show3YearsTotalForClient"
						 [showDownloadButtonText]="showDownloadButtonText" [disablePdfDownloadButton]="disablePdfDownloadButton"
						 [tooltipForDisableDownloadButton]=tooltipForDisableDownloadButton></pricing-summary>
	}
</div>
